export * from './awaitMediaLoaded';
export * from './bufferToImage';
export * from './createCanvas';
export * from './extractFaces';
export * from './extractFaceTensors';
export * from './fetchImage';
export * from './fetchJson';
export * from './fetchNetWeights';
export * from './fetchOrThrow';
export * from './getContext2dOrThrow';
export * from './getMediaDimensions';
export * from './imageTensorToCanvas';
export * from './imageToSquare';
export * from './isMediaElement';
export * from './isMediaLoaded';
export * from './loadWeightMap';
export * from './matchDimensions';
export * from './NetInput';
export * from './resolveInput';
export * from './toNetInput';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/dom/index.js
// module id = 101
// module chunks = 0